const { ContextQuestions } = require('./ContextQuestions');
const { CreateContextQuestions } = require('./CreateContextQuestions');

export { ContextQuestions, CreateContextQuestions };
